import { ActivatedRoute } from '@angular/router';
import { IBreadCrumb } from 'app/shared/components/breadcrumb/breadcrumb.interface';

/** Route path segment whose dynamic parameter is shown instead of a label. */
const FLEET_MONITORING_PATH = 'monitoramento-frota';
const ROUTE_PARAM_PREFIX = ':';

/**
 * Builds the breadcrumb trail of the current page from the route tree.
 *
 * @param route - The route to start from, usually `ActivatedRoute.root`.
 * @param url - The URL built so far by the parent routes.
 * @param breadcrumbs - The crumbs collected so far by the parent routes.
 * @returns One crumb per route that declares `data.breadcrumb`, outermost first.
 *
 * @remarks
 * Routes without `data.breadcrumb` add no crumb but still extend the URL. On
 * fleet monitoring routes ending in a parameter, the crumb shows the parameter
 * value (the device) instead of the route label.
 */
export function buildBreadcrumbs(
  route: ActivatedRoute,
  url = '',
  breadcrumbs: IBreadCrumb[] = [],
): IBreadCrumb[] {
  const routeData = route.routeConfig?.data;
  let label = '';
  let path = '';
  if (routeData) {
    label = routeData['breadcrumb'] ?? '';
    path = route.routeConfig?.path ?? '';
  }

  const lastRoutePart = path.split('/').pop() ?? '';
  const isDynamicRoute = lastRoutePart.startsWith(ROUTE_PARAM_PREFIX);
  if (
    isDynamicRoute &&
    !!route.snapshot &&
    path.includes(FLEET_MONITORING_PATH)
  ) {
    const paramName = lastRoutePart.slice(ROUTE_PARAM_PREFIX.length);
    path = path.replace(lastRoutePart, route.snapshot.params[paramName]);
    label = route.snapshot.params[paramName];
  }

  let nextUrl = url;
  if (path) {
    nextUrl = `${url}/${path}`;
  }

  let crumbs = breadcrumbs;
  if (label) {
    crumbs = [...breadcrumbs, { label, url: nextUrl }];
  }

  if (route.firstChild) {
    return buildBreadcrumbs(route.firstChild, nextUrl, crumbs);
  }
  return crumbs;
}
